module.exports = __webpack_public_path__ + "media/images/about-us/media2-05861e303192983c5fc5f9d7e56881b2.png";